export const SORT_TYPES = {
  text: { asc: 'A → Z', desc: 'Z → A' },
  date: { asc: 'Earliest → Latest', desc: 'Latest → Earliest' },
  number: { asc: '1 → 9', desc: '9 → 1' },
  currency: { asc: 'Lowest → Highest', desc: 'Highest → Lowest' },
};
